export const initLocationData = {
    location: {
        type: "string",
        result: "string"
    },
    Area: {
        type: "string",
        result: 0
    },
    Terrain: {
        type: "string",
        result: [
            0, 0, 0, 0, 0
        ]
    },
    Vegetation_height: {
        type: "string",
        result: 0
    },
    Weather: {
        type: "string",
        result: [
            0, 0, 0, 0, 0
        ]
    },
}


export const initQuestionsData = {
    dev_per_type: {
        type: "string",
        result: [
            0
        ]
    },
    sensor_rate: {
        type: "string",
        result: [
            0
        ]
    },
    sensor_freq: {
        type: "string",
        result: [
            0
        ]
    },
    sensor_lat: {
        type: "string",
        result: [
            0
        ]
    },
    type_of_drones: {
        type: "string",
        result: [
            0
        ]
    },
    drone_service: {
        type: "string",
        result: [
            0
        ]
    },
    drone_altitude: {
        type: "string",
        result: [
            0
        ]
    },
    drone_image_proc: {
        type: "string",
        result: [
            0
        ]
    },
    drone_image_lat: {
        type: "string",
        result: [
            0
        ]
    },
    drone_iot_lat: {
        type: "string",
        result: [
            0
        ]
    },
    personal_dev_type: {
        type: "string",
        result: [
            0,0
        ]
    },
    tablet_internet: {
        type: "string",
        result: [
            0
        ]
    },
    tablet_image_proc: {
        type: "string",
        result: [
            0
        ]
    },
    tablet_image_lat: {
        type: "string",
        result: [
            0
        ]
    },
    tablet_rate_down: {
        type: "string",
        result: [
            0
        ]
    },
    laptop_internet: {
        type: "string",
        result: [
            0
        ]
    },
    laptop_image_proc: {
        type: "string",
        result: [
            0
        ]
    },
    laptop_image_lat: {
        type: "string",
        result: [
            0
        ]
    },
    laptop_rate_down: {
        type: "string",
        result: [
            0
        ]
    },
    personal_internet: {
        type: "string",
        result: [
            0
        ]
    },
    personal_proc: {
        type: "string",
        result: [
            0
        ]
    },
    personal_image_lat: {
        type: "string",
        result: [
            0
        ]
    },
    personal_rate_down: {
        type: "string",
        result: [
            0
        ]
    },
    camera_rate: {
        type: "string",
        result: [
            0
        ]
    },
    camera_proc: {
        type: "string",
        result: [
            0
        ]
    },
    camera_image_lat: {
        type: "string",
        result: [
            0
        ]
    },
    camera_image_freq: {
        type: "string",
        result: [
            0
        ]
    },
    robot_type: {
      type: "string",
      result: ""
    },
    robot_service: {
        type: "string",
        result: [
            0,
            0,
            0
        ]
    },
    robot_image_rate: {
        type: "string",
        result: [
            0,
            0,
            0
        ]
    },
    robot_image_freq: {
        type: "string",
        result: [
            0,
            0,
            0,
            0
        ]
    },
    robot_image_proc: {
        type: "string",
        result: [
            0,
            0
        ]
    },
    robot_image_lat: {
        type: "string",
        result: [
            0,
            0,
            0
        ]
    },
    robot_power: {
        type: "string",
        result: 0
    },
    robot_cost: {
        type: "string",
        result: 0
    },
    robot_iot_rate: {
        type: "string",
        result: [
            0,
            0
        ]
    },
    robot_iot_freq: {
        type: "string",
        result: [
            0,
            0,
            0,
            0
        ]
    },
    robot_iot_proc: {
        type: "string",
        result: [
            0,
            0
        ]
    },
    robot_iot_lat: {
        type: "string",
        result: [
            0,
            0
        ]
    },
    robot_speech_freq: {
        type: "string",
        result: [
            0,
            0,
            0
        ]
    },
    robot_speech_proc: {
        type: "string",
        result: [
            0,
            0
        ]
    },
    robot_speech_lat: {
        type: "string",
        result: [
            0,
            0
        ]
    }
}